import { EUTYC4 } from "./CGUTranslation";
import { EUTYC3 } from "./PPDTranslation";
import { EU1 } from "./translations1";
import { EU2 } from "./translations2";
import { EUTYC1 } from "./TycsTranslation1";
import { EUTYC2 } from "./TycsTranslation2";

const EU = { ...EU1, ...EU2, ...EUTYC1, ...EUTYC2, ...EUTYC3, ...EUTYC4 };
export { EU };



